define('gumbo-js-client-lib/forms/liveData/PlayerForm',['require','exports','module','jquery','./PlayerStatsForm','./PlayerSeasonStatsForm'],function(require, exports, module) {
	var $ = require("jquery"),
		statsFormat = require("./PlayerStatsForm"),
		seasonStatsFormat = require("./PlayerSeasonStatsForm");

	return {
		name: {
			first: null,
			last: null,
			display: null,
			boxname: null,
			abbrev: null
		},
		id: null,
		team: null,
		teamID: null,
		position: null,
		batterPitcher: null,
		shirtNum: null,
		height: null,
		rightLeft: null,
		stands: null,
		note: null,
		boxnote: null,
		homeAway: null,
		mugshot: null,
		mugshotRetina: null,
		gameStats: $.extend({}, statsFormat),
		seasonStats: $.extend({}, seasonStatsFormat),
		status: {
			isCurrentPitcher: null,
			isOnBench: null,
			isCurrentBatter: null,
			isSubstitute: null
		}
	}
});
